import { useEffect, useState } from "react";
import { Download } from "lucide-react";

// Bouton « Télécharger l'application » (PWA).
// Ne s'affiche QUE sur navigateur mobile (téléphone), quand l'app est installable,
// et disparaît une fois installée (mode standalone ou après installation).
export function InstallAppButton({ variant = "header" }) {
  const [deferred, setDeferred] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 639px)");
    const upd = () => setIsMobile(mq.matches);
    upd();
    mq.addEventListener?.("change", upd);
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => setDeferred(null);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      mq.removeEventListener?.("change", upd);
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const standalone = typeof window !== "undefined" && window.matchMedia?.("(display-mode: standalone)").matches;
  if (standalone || !isMobile || !deferred) return null;

  const install = async () => {
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
  };

  if (variant === "login") {
    return (
      <button
        type="button"
        onClick={install}
        data-testid="install-app-btn"
        className="inline-flex items-center gap-2 rounded-lg border border-brand-600 px-3 py-2 text-sm font-semibold text-brand-700 hover:bg-brand-50 transition-colors"
      >
        <Download className="h-4 w-4" /> Télécharger l'application
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={install}
      data-testid="install-app-btn"
      title="Télécharger l'application"
      className="inline-flex items-center gap-1.5 rounded-full bg-brand-600 px-3 py-2 text-sm font-semibold text-white hover:bg-brand-700 transition-colors"
    >
      <Download className="h-4 w-4" />
    </button>
  );
}
